import {useCallback, useMemo, useState} from 'react';

import {Item} from '../types';

type UseExpensesState = {
	expenses: Item[];
	addExpense: (expense: Item) => void;
	removeExpense: (id: string) => void;
	replaceExpenses: (expenses: Item[]) => void;
	hasMileageExpenses: boolean;
}

export const useExpensesState = (): UseExpensesState => {
	const [expenses, setExpenses] = useState<Item[]>([]);

	const addExpense = useCallback((expense: Item) => {
		setExpenses([...expenses, expense]);
	}, [expenses]);

	const removeExpense = useCallback((id: string) => {
		setExpenses([...expenses.filter((item) => item.id !== id)]);
	}, [expenses]);

	const replaceExpenses = useCallback((newExpenses: Item[]) => {
		setExpenses(newExpenses);
	}, []);

	const hasMileageExpenses = useMemo(() => {
		return expenses.some((item) => item.type === 'mileage');
	}, [expenses]);

	return {
		expenses,
		addExpense,
		removeExpense,
		replaceExpenses,
		hasMileageExpenses,
	};
};